import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
// Легаси-слой грузится до App и его компонентов (раньше это делал App.tsx); порядок слоёв: легаси → ds/* → brand/* → signature.css.
import './styles/brand-tokens.css';
import './styles/main.css';
import './styles/style.css';
import './styles/auth.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/modal-system.css';
// Дизайн-система v2 грузится последней, чтобы перебивать легаси без !important.
import './styles/ds/tokens.css';
import './styles/ds/base.css';
import './styles/ds/primitives.css';
import './styles/ds/shell.css';
import './styles/ds/pages/admin.css';
import './styles/ds/pages/connector.css';
import './styles/ds/pages/profile.css';
import './styles/ds/pages/datasets.css';
import './styles/ds/pages/multiagent.css';
import './styles/ds/pages/configurator.css';
import './styles/ds/pages/panels.css';
import './styles/ds/pages/leaderboard.css';
import './styles/ds/brand.css';
import './styles/ds/brand/shell.css';
import './styles/ds/brand/primitives.css';
import './styles/ds/brand/modals.css';
import './styles/ds/brand/multiagent.css';
import './styles/ds/brand/connector.css';
import './styles/ds/brand/panels.css';
import './styles/ds/brand/admin.css';
import './styles/ds/brand/profile.css';
import './styles/ds/brand/signature.css';
import { PostHogProvider } from 'posthog-js/react';
import { readEnv } from './config/env';

const options = {
  api_host: readEnv('REACT_APP_POSTHOG_HOST') || undefined,
  defaults: '2025-05-24',
} as const;

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <PostHogProvider apiKey={readEnv('REACT_APP_POSTHOG_KEY')} options={options}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
